module.exports = {"button":"Schließen","rodoStart":"Ich bestätige, dass ich","rodoEnd":"die Informationsklausel von Lemlock gelesen habe","dataStart":"Einwilligung zur","dataEnd":"Datenverarbeitung zwecks Kontaktaufnahme","marketingEnd":"Datenverarbeitung zu Marketingzwecken"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/de/consent/common.json
// module id = 206
// module chunks = 0